module.exports = __webpack_public_path__ + "assets/img/ab50-eu.svg";